// #genai
const mockNewSubscriptionDashboardData = {
  subscriptions: [
    {
      id: 'sub-001',
      subscriptionSkuName: 'Walls, Windows & Doors Subscription',
      subscriptionItemId: 'item-001',
      monthlyFee: 1396,
      startDate: '2025-01-01',
      endDate: '2026-01-01',
      usedQty: 121,
      includedQty: 118,
      overageRatePerUnit: 10,
    },
    {
      id: 'sub-002',
      subscriptionSkuName: 'Roof Subscription',
      subscriptionItemId: 'item-002',
      monthlyFee: 1396,
      startDate: '2025-01-01',
      endDate: '2026-01-01',
      usedQty: 38,
      includedQty: 118,
      overageRatePerUnit: 10,
    },
    {
      id: 'sub-003',
      subscriptionSkuName: 'Bid Perfect Subscription',
      subscriptionItemId: 'item-003',
      monthlyFee: 1396,
      startDate: '2025-01-01',
      endDate: '2026-01-01',
      usedQty: 38,
      includedQty: 118,
      overageRatePerUnit: 10,
    },
  ],
  fees: {
    nonSubscription: 372,
    deliveryFees: 9,
    integrationFees: 17,
  },
};

export default mockNewSubscriptionDashboardData;
